<div class="page-layout carded fullwidth inner-scroll">
  <!-- CENTER -->
  <div class="center">
    <!-- CONTENT CARD -->
    <div class="content-card">
      <!-- CONTENT TOOLBAR -->
      <div
        class="toolbar px-24 py-8"
        fxLayout="row"
        fxLayoutAlign="space-between center"
      >
        <toolbar-heading
          [showBackButton]="true"
          [heading]="'Book Reverse Order'"
        ></toolbar-heading>
      </div>

      <data-loader
        *ngIf="loadingIndicator; else showOrder"
        [msg]="'Fetching order...'"
      ></data-loader>

      <ng-template #showOrder>
        <mat-horizontal-stepper
          linear
          labelPosition="end"
          #stepper
          class="w-100-p disable-mat-header-click"
        >
          <!-- Name and and address of the user -->
          <mat-step [stepControl]="itemsDetailsStep">
            <ng-template matStepLabel>Review Items</ng-template>
            <div class="large-form-container" fusePerfectScrollbar>
              <edit-items
                [itemDetailsForm]="itemsDetailsStep"
                [order]="orderData"
                [reverseQCEnabled]="reverseQCEnabled"
                [reverseQCForm]="reverseQCStep"
                (removeItemEvent)="removeItem($event)"
                (reverseQCChange)="onReverseQCChange($event)"
                (uploadImageEvent)="uploadImage($event.file, $event.itemIndex)"
                (addImageUrlEvent)="addImageUrl($event.itemIndex, $event.url)"
                (removeImageEvent)="removeImageUrl($event.itemIndex, $event.imageIndex)"
              ></edit-items>

              <footer-navigation
                [hideBackButton]="true"
                (moveNext)="handleStepperNext()"
              >
              </footer-navigation>

              <!-- <div fxLayoutAlign="end center" class="px-24 py-16">
                <button
                  (click)="handleStepperNext()"
                  mat-flat-button
                  color="primary"
                >
                  Next
                </button>
              </div> -->
            </div>
          </mat-step>

          <mat-step [stepControl]="singleBoxStep">
            <ng-template matStepLabel>Box Details</ng-template>
            <div class="large-form-container" fusePerfectScrollbar>
              <reverse-box-details
                [singleBoxForm]="singleBoxStep"
                [boxList]="boxList"
              ></reverse-box-details>

              <footer-navigation
                [hideBackButton]="false"
                (moveNext)="handleStepperNext()"
                (movePrevious)="handleStepperPrevious()"
              >
              </footer-navigation>
            </div>
          </mat-step>

          <!-- list of all couriers and prices -->
          <mat-step [stepControl]="courierPartnerStep">
            <ng-template matStepLabel>Select Courier Partner</ng-template>

            <div class="large-form-container" fusePerfectScrollbar>
              <!-- <select-courier
                [order]="orderData"
                [courierPartnerForm]="courierPartnerStep"
                [courierPrices]="rateTableData"
              ></select-courier> -->

              <view-preference
                *ngIf="rateTableData.length"
                [viewPreference]="viewPreference"
                [showViews]="viewsList"
                componentName="select-courier"
                (viewChanged)="viewPreferenceChange($event)"
              ></view-preference>

              <!-- <app-courier-partner-charges
                [order]="orderData"
                [courierPartnerForm]="courierPartnerStep"
                [courierPrices]="rateTableData"
              ></app-courier-partner-charges> -->

              <select-courier-partner
                [viewPreference]="viewPreference"
                [courierPartnerForm]="courierPartnerStep"
                [courierPrices]="rateTableData"
              ></select-courier-partner>

              <!-- [nextButtonDisable]="courierPartnerStep.invalid" -->
              <!-- [hideBackButton]="true" -->
              <footer-navigation
                footerMessage="Total Couriers: {{ rateTableData.length }}"
                (moveNext)="handleStepperNext()"
                (movePrevious)="handleStepperPrevious()"
              >
              </footer-navigation>

              <!-- <div
                fxLayout="row"
                fxLayoutAlign="end center"
                class="px-24 py-16"
                fxLayoutGap="10px"
              >
                <button
                  mat-flat-button
                  matStepperNext
                  color="primary"
                  [disabled]="courierPartnerStep.invalid"
                >
                  Next
                </button> 
              </div>-->
            </div>
          </mat-step>

          <mat-step>
            <ng-template matStepLabel>Confirm Reverse Order</ng-template>

            <ng-container *ngIf="stepper.selectedIndex === 3">
              <div class="large-form-container" fusePerfectScrollbar>
                <confirm-reverse
                  [order]="orderData"
                  [courierPartnerForm]="courierPartnerStep"
                  [reverseQCForm]="reverseQCStep"
                  [reverseQCEnabled]="reverseQCEnabled"
                  [itemsForm]="itemsDetailsStep"
                ></confirm-reverse>

                <footer-navigation
                  nextButtonText="Book Reverse Order"
                  [nextButtonColor]="'accent'"
                  (moveNext)="confirmReverseComponent.onSubmit()"
                  (movePrevious)="handleStepperPrevious()"
                >
                </footer-navigation>
              </div>
            </ng-container>
          </mat-step>
        </mat-horizontal-stepper>
      </ng-template>
    </div>
    <!-- CONTENT CARD -->
  </div>
  <!-- CENTER -->
</div>
